module.exports = __webpack_public_path__ + "static/media/burger.be93cb1b.png";